import { nextTick } from 'vue'
import { createWebHistory, createRouter } from 'vue-router'
import { detectCtrlClick } from '@/utils/index.js'
import store from '../store/'
import HomePage from '@/views/Dashboard/HomePage'
import SignIn from '@/views/Auth/SignIn'
import WhitelistedCTA from '@/views/Cta/WhitelistedCTA'
import Whitelist from '@/views/Cta/Whitelist'
import Links from '@/views/Links/Links'
import NewLink from '@/views/Links/NewLink'
import LinkReport from '@/views/Links/LinkReport'
import Domains from '@/views/DomainManagement/Domains'
import CreateDomain from '@/views/DomainManagement/CreateDomain'
import Webhook from '@/views/Webhooks/Webhook'
import AccountSettings from '@/views/Settings/AccountSettings'
import UserManagement from '@/views/Settings/UserManagement'
import AppBranding from '@/views/Settings/AppBranding'
import Analytics from '@/views/Analytics/AnalyticsDashboard'
import Subscription from '@/views/Subscription/Subscription'
import BulkWhitelistedCTA from '@/views/Cta/BulkWhitelistedCTA'
import BulkWhitelist from '@/views/Cta/BulkWhitelist'
import BulkLinks from '@/views/Links/BulkLinks'
import BulkLinkCreate from '@/views/Links/BulkLinkCreate'

const routes = [
    {
        path: '/signin/sso/:token',
        name: 'signin-sso',
        meta: { layout: 'empty' },
        component: SignIn
    },
    {
        path: '/signin/',
        name: 'signin',
        meta: { layout: 'empty' },
        component: SignIn
    },
    {
        path: '/',
        name: 'Dashboard',
        component: HomePage,
        meta: { title: 'CTA Registration | Dashboard' }
    },
    {
        path: '/cta',
        name: 'CTA Whitelisting',
        component: WhitelistedCTA,
        meta: { title: 'CTA Registration | Whitelisted CTAs' }
    },
    {
        path: '/cta/whitelist',
        name: 'Whitelist CTA',
        component: Whitelist,
        meta: { title: 'CTA Registration | Whitelist' }
    },
    {
        path: '/cta/bulk',
        name: 'Bulk CTA Whitelisting',
        component: BulkWhitelistedCTA,
        meta: { title: 'CTA Registration | Bulk Whitelisted CTAs' }
    },
    {
        path: '/cta/bulkwhitelist',
        name: 'Bulk Whitelist CTA',
        component: BulkWhitelist,
        meta: { title: 'CTA Registration | Bulk Whitelist' }
    },
    {
        path: '/subscription',
        name: 'Subscription',
        component: Subscription,
        meta: { title: 'CTA Registration | Subscription' }
    },
    {
        path: '/link',
        name: 'URL Shortener',
        component: Links,
        meta: { title: 'CTA Registration | Links' }
    },
    {
        path: '/link/create',
        name: 'Create a short link',
        component: NewLink,
        meta: { title: 'CTA Registration | Short Link' }
    },
    {
        path: '/link/report',
        name: 'Link Details',
        component: LinkReport,
        meta: { title: 'CTA Registration | Link Report' }
    },
    {
        path: '/link/bulk',
        name: 'Bulk URL Shortening',
        component: BulkLinks,
        meta: { title: 'CTA Registration | Bulk Links' }
    },
    {
        path: '/link/bulkcreate',
        name: 'Bulk Upload',
        component: BulkLinkCreate,
        meta: { title: 'CTA Registration | Bulk Create Link' }
    },
    // {
    //     path: '/domain',
    //     name: 'Branded Domains',
    //     component: Domains,
    //     meta: { title: 'CTA Registration | Branded Domains' }
    // },
    {
        path: '/domain/create',
        name: 'Add a custom domain',
        component: CreateDomain,
        meta: { title: 'CTA Registration | Add Custom Domain' }
    },
    {
        path: '/analytics',
        name: 'Analytics',
        component: Analytics,
        meta: { title: 'CTA Registration | Analytics' }
    },
    {
        path: '/webhook',
        name: 'Webhooks',
        component: Webhook,
        meta: { title: 'CTA Registration | Webhooks' }
    },
    {
        path: '/accountsettings',
        name: 'Account Settings',
        component: AccountSettings,
        meta: { title: 'CTA Registration | Account Settings' }
    },
    {
        path: '/users',
        name: 'Users',
        component: UserManagement,
        meta: { title: 'CTA Registration | User Management' }
    },
    {
        path: '/appbranding',
        name: 'Application Branding',
        component: AppBranding,
        meta: { title: 'CTA Registration | Application Branding' }
    }

]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = !(store.getters.currentUser && !localStorage.token)
    if (!isAuthenticated) {
        store.dispatch('unsetUser')
        router.push('/signin?redirect=' + router.currentRoute.path)
    } else {
        next()
    }
})

router.openInNewTab = (routeData) => {
    const resolvedRoute = router.resolve(routeData)
    window.open(resolvedRoute.href, '_blank')
}

router.controlledPush = (routeData, eventData) => {
    if (eventData && detectCtrlClick(eventData)) {
        const resolvedRoute = router.resolve(routeData)
        window.open(resolvedRoute.href, '_blank')
    } else {
        router.push(routeData)
    }
}

const DEFAULT_TITLE = 'CTA Registration'
router.afterEach(async (to, from) => {
    nextTick().then(() => {
        document.title = to.meta.title || DEFAULT_TITLE
    })
})

export default router
